import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useEffect } from 'react';
import AboutHero from './components/AboutHero';
import HakkimizdaDetailed from './components/HakkimizdaDetailed';
import AboutStory from './components/AboutStory';
import AboutValues from './components/AboutValues';
import TrustSection from '@/pages/home/components/TrustSection';
import TeamSection from '@/pages/home/components/TeamSection';
import FAQ, { getFAQSchema } from '@/pages/home/components/FAQ';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://biffdigital.com';
const logoUrl = 'https://storage.helloreaddy.io/project_files/8cf86b48-d09c-4ec8-816e-12bbed2b078b/1e3fa9b9-1413-4092-84fc-01303456e9e9_compressed_Biff-Digital-Logo.webp';

const aboutFAQItems = [
  {
    question: 'BIFF Digital nedir?',
    answer:
      'BIFF Digital, 2021\'de İzmir\'de kurulan; 2023\'te Ankara\'yı merkez yapan, 2024\'ten itibaren İstanbul ofisiyle büyüyen; endüstriyel firmalar ve e-ticaret markaları başta olmak üzere B2B şirketlere performans pazarlaması, marka stratejisi, SEO, web geliştirme ve nöropazarlama hizmeti veren bir dijital pazarlama ve reklam ajansıdır.',
  },
  {
    question: 'BIFF Digital nerede hizmet veriyor?',
    answer:
      'BIFF Digital\'in merkezi Ankara, Çankaya\'dadır (Söğütözü Cad. No: 2, Koç Kuleleri C Blok). Ankara, İstanbul ve İzmir\'deki markalara hizmet verir; ulusal ve uluslararası ölçekte büyümek isteyen şirketlerle de çalışır.',
  },
  {
    question: 'BIFF Digital hangi hizmetleri sunuyor?',
    answer:
      'BIFF Digital dört ana alanda hizmet verir: Growth (performans pazarlaması, SEO, CRO, analytics), Campaigns (marka lansmanları, kampanya ve itibar yönetimi), Creative (marka stratejisi, branding, içerik üretimi) ve Infrastructure (web geliştirme, yazılım, otomasyon, veri altyapısı).',
  },
  {
    question: 'BIFF Digital hangi sektörlerle çalışıyor?',
    answer:
      'BIFF Digital özellikle endüstriyel firmalar ve e-ticaret markaları olmak üzere; teknoloji şirketleri, yazılım girişimleri, üretim şirketleri ve yüksek büyüme hedefleyen B2B işletmelerle çalışır.',
  },
  {
    question: 'BIFF Digital\'i diğer Ankara dijital pazarlama ajanslarından ayıran nedir?',
    answer:
      'BIFF Digital, hizmetleri ayrı ayrı sunmak yerine strateji, kreatif, medya ve teknolojiyi tek bir büyüme sistemi içinde birleştirir. Ayrıca nöropazarlama ve EEG/biyometrik ölçüm temelli kullanıcı davranışı analizini kreatif süreçlere doğrudan entegre eder.',
  },
  {
    question: 'BIFF Digital ile nasıl iletişime geçebilirim?',
    answer:
      'BIFF Digital\'e +90 555 710 19 68 numaralı telefondan veya web sitesindeki iletişim formu üzerinden, hafta içi 09:00-18:00 saatleri arasında ulaşabilirsiniz.',
  },
];

const faqSchema = getFAQSchema(aboutFAQItems);

const aboutSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: 'BIFF Digital - Ankara Dijital Pazarlama Ajansı',
      description:
        'BIFF Digital, Ankara merkezli, İstanbul ve İzmir\'de hizmet veren, endüstriyel ve e-ticaret sektörlerine odaklanan, performans pazarlama, marka stratejisi, nöropazarlama ve web geliştirmeyi tek bir büyüme sisteminde birleştiren growth & campaign agency.',
      url: `${siteUrl}/ankara-dijital-pazarlama-ajansi`,
      about: {
        '@type': 'Organization',
        name: 'BIFF Digital',
        url: siteUrl,
        logo: logoUrl,
        foundingDate: '2021-08-11',
        numberOfEmployees: '10',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17',
          addressLocality: 'Çankaya',
          addressRegion: 'Ankara',
          addressCountry: 'TR',
          postalCode: '06530',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 39.92077,
          longitude: 32.85411,
        },
        areaServed: [
          { '@type': 'City', name: 'Ankara' },
          { '@type': 'City', name: 'İstanbul' },
          { '@type': 'City', name: 'İzmir' },
        ],
        knowsAbout: [
          'Growth Marketing', 'Performans Pazarlama', 'Marka Stratejisi',
          'Nöropazarlama', 'Web Geliştirme', 'SEO', 'B2B Lead Generation',
          'İçerik Üretimi', 'Sosyal Medya Yönetimi', 'E-Ticaret',
        ],
        sameAs: [
          'https://www.instagram.com/biffdigital',
          'https://www.youtube.com/@Biff-Digital',
          'https://www.linkedin.com/company/biff-digital',
        ],
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
        ],
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Ankara Dijital Pazarlama Ajansı', item: `${siteUrl}/ankara-dijital-pazarlama-ajansi` },
      ],
    },
    {
      '@type': 'SpeakableSpecification',
      cssSelector: ['.speakable-summary'],
    },
    faqSchema,
  ],
};

export default function Hakkimizda() {
  useEffect(() => {
    document.title = 'BIFF Digital | Ankara Dijital Pazarlama Ajansı - Hakkımızda, Ekibimiz, S.S.S.';

    // Per-page canonical URL
    const canonicalUrl = `${siteUrl}/ankara-dijital-pazarlama-ajansi`;
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    return () => {
      // Reset canonical to homepage on unmount
      link?.setAttribute('href', siteUrl);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <Navbar />
      <main className="pt-16 md:pt-20">
        <AboutHero />
        <HakkimizdaDetailed />
        <AboutStory />
        <AboutValues />
        <TrustSection />
        <TeamSection />
        <FAQ
          items={aboutFAQItems}
          sectionTitle="SIK SORULANLAR"
          sectionSubtitle="MERAK ETTİKLERİN"
          sectionSummary="BIFF Digital hakkında en sık sorulan soruları, veriye dayalı ve somut cevaplarla burada topladık."
          speakableClass={false}
        />
      </main>
      <Footer />
    </div>
  );
}